import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import './limaLogin.css';

// Opened from the "Reset your password" email. Sets a new password with the link's one-time code.
const ResetPassword: React.FC = () => {
  useEffect(() => {
    const before = document.title;
    document.title = 'LIMA | Portal & Shipment | Reset password';
    return () => { document.title = before; };
  }, []);
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  // Back to the sign-in the request came from: dealer portal, client portal, or this one.
  const portal = searchParams.get('portal');
  // Another LIMA site's sign-in (Sales Hub, accounting, quote site, Ticket Hub, blog…), if the link names one.
  const back = (() => { try { const u = new URL(searchParams.get('back') || ''); return u.protocol === 'https:' && /^(([a-z0-9-]+\.)*limaautomotive\.com|limaautomotive\.netlify\.app|limacrmleads\.netlify\.app|limaaccounting\.netlify\.app|limatickethub\.netlify\.app|adminlimacargo\.netlify\.app|devlimacrm\.netlify\.app|limacrm\.netlify\.app|limaapi\.onrender\.com)$/i.test(u.hostname) ? u.origin + u.pathname : ''; } catch { return ''; } })();
  const signIn = back || (portal === 'dealer' ? '/dealer/login' : portal === 'user' ? '/user/login' : '/login');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(token ? null : 'This link is not valid. Please ask for a new one.');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setError(null);
    setLoading(true);
    try {
      const res = await fetch('/.netlify/functions/reset-password', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, newPassword: password }) });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || 'Something went wrong. Please try again.');
      setDone(true);
    } catch (err: any) {
      setError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="lima-login">
      <div className="ll-card">
        <a href="https://limaautomotive.com/" aria-label="LIMA Automotive home" style={{ display: 'block', width: 'fit-content', margin: '0 auto' }}><img className="ll-logo" src="/LIMA_LOGO_LOGIN.png" alt="LIMA Automotive" /></a>
        <span className="ll-pill">Shipment Portal</span>
        <h1 className="ll-title">Set a new password</h1>
        <p className="ll-sub">Choose a new password for your LIMA account</p>
        <div className="ll-msg" role="alert" aria-live="polite">
          {error ? <div className="ll-alert err" title={error}>{error}</div>
            : done ? <div className="ll-alert ok">Password changed. You can sign in now.</div> : null}
        </div>
        <form className="ll-form" onSubmit={submit} noValidate>
          <label className="ll-field" htmlFor="reset-password">
            <span className="ll-label">New password</span>
            <input className="ll-input" id="reset-password" type="password" autoComplete="new-password" autoFocus
              value={password} onChange={(e) => setPassword(e.target.value)} disabled={loading || done || !token} />
            <span className="ll-help">At least 6 characters</span>
          </label>
          <label className="ll-field" htmlFor="reset-confirm">
            <span className="ll-label">Confirm new password</span>
            <input className="ll-input" id="reset-confirm" type="password" autoComplete="new-password"
              value={confirm} onChange={(e) => setConfirm(e.target.value)} disabled={loading || done || !token} />
          </label>
          {done ? (
            <a className="ll-btn" href={signIn} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }}>Go to sign in</a>
          ) : (
            <button type="submit" className="ll-btn" disabled={loading || !token}>{loading ? 'Saving…' : 'Save new password'}</button>
          )}
        </form>
        <p className="ll-alt">
          Link not working? <a className="ll-link" href={back ? back : `${signIn}?tab=forgot`}>Send a new one</a>
        </p>
      </div>
      <div className="ll-foot">LIMA Automotive Industries<br /><span style={{ whiteSpace: 'nowrap' }}>Toll Free +1 877 298-0911</span></div>
    </div>
  );
};

export default ResetPassword;
